import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const ClassesVItovIII = () => {
    useEffect(() => {
        document.title = 'Classes VI - VIII -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                 <li>Classes VI - VIII</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                       <h1 className="syl">    Syllabus 2025-2026 <span> {/*Syllabus will be updated shortly */}</span></h1>
                    
                         {/* <h5 className="head">    Syllabus 2024-2025</h5> */}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12"> 
                          <h6>Class VI</h6>
                            <ul className="list mainlist"> 
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIEnglish.pdf" target="_blank"> English  </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIHindi.pdf" target="_blank">Hindi    </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIMath.pdf" target="_blank">Maths    </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIScience.pdf" target="_blank">Science  </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVISocialSci.pdf" target="_blank">Social Science   </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVISanskrit.pdf" target="_blank">Sanskrit     </Link> </li>
                                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVICS.pdf" target="_blank">Computer Science </Link> </li>
                                </ul>  
                        <h6> Class VII</h6>
                        <ul className="list mainlist"> 
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIEnglish.pdf" target="_blank"> English  </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIHindi.pdf" target="_blank">Hindi    </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIMaths-1.pdf" target="_blank">Maths    </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIScience-2.pdf" target="_blank">Science  </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIISocialSci.pdf" target="_blank">Social Science   </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIISanskrit.pdf" target="_blank">Sanskrit     </Link> </li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIICS.pdf" target="_blank">Computer Science </Link> </li>
                      </ul> 
                      <h6> Class VIII</h6>
                      <ul className="list mainlist"> 
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIIEnglish.pdf" target="_blank"> English  </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIIHindi.pdf" target="_blank">Hindi    </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIIMaths-1.pdf" target="_blank">Maths    </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIIScience.pdf" target="_blank">Science  </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIISocialSci.pdf" target="_blank">Social Science   </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIISanskrit.pdf" target="_blank">Sanskrit     </Link> </li>
                      <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/classVIIICS.pdf" target="_blank">Computer Science </Link> </li>
                    </ul> 
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default ClassesVItovIII